export default [
  {
    icon: 'star',
    color: 'currentColor',
    size: 16,
    position: { top: '3.52%', left: '0.44%' },
    animationDuration: '2.2s',
  },
  {
    icon: 'star',
    color: 'currentColor',
    size: 12,
    position: { bottom: '35.21%', left: '27.16%' },
    animationDuration: '2.6s',
  },
  {
    icon: 'star',
    color: 'currentColor',
    size: 16,
    position: { top: '5.63%', left: '41.34%' },
    animationDuration: '2.4s',
  },
  {
    icon: 'star',
    color: 'currentColor',
    size: 29,
    position: { bottom: '-4.06%', right: '43.51%' },
    animationDuration: '2.8s',
  },
  {
    icon: 'star',
    color: 'currentColor',
    size: 10,
    position: { top: '7.74%', right: '20.74%' },
    animationDuration: '2.4s',
  },
  {
    icon: 'star',
    color: 'currentColor',
    size: 28,
    position: { bottom: '30.44%', right: '-0.06%' },
    animationDuration: '2.4s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 20,
    position: { bottom: '5.63%', left: '20.29%' },
    animationDuration: '2.4s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { bottom: '5.63%', left: '33.73%' },
    animationDuration: '2.4s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { top: '5.63%', left: '38.51%' },
    animationDuration: '3s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 10,
    position: { bottom: '16.19%', right: '42.39%' },
    animationDuration: '2.2s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 10,
    position: { bottom: '8.45%', right: '24.77%' },
    animationDuration: '2.9s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { bottom: '25.35%', right: '22.53%' },
    animationDuration: '2.5s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 10,
    position: { bottom: '32.39%', right: '13.43%' },
    animationDuration: '2.8s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 16,
    position: { top: '38.02%', right: '24.64%' },
    animationDuration: '2.2s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { top: '35.21%', right: '11.97%' },
    animationDuration: '2.6s',
  },
].map((props, key) => ({ ...props, key }));
